import RankingContentCard from './RankingContentCard';
import AdBanner from '../../../common/component/AdBanner';
import BigOverContentCardV4 from '../../../common/component/BigOverContentCardV4';
import ContentCardWrapperV4 from '../../../common/component/ContentCardWrapperV4';
import {Page} from '../../../common/constant/page';
import useScreenType from '../../../common/hook/useScreenType';
import {IAdBanner} from '../../../common/type';
import {routeTo} from '../../../common/util/PageRouter';
import {getContentOrdNum} from '../../common/common';
import {sendHomeEvent, sendHomeViewImp} from '../../common/tracking';
import {IBigOverContent} from '../../common/type';
import {IRankingContent} from '../type';

interface IProps {
  bigContent?: IBigOverContent;
  contents: IRankingContent[];
  talkBoard?: IAdBanner;
  placement?: string;
}

export default function RankingContentList({
  bigContent,
  contents,
  talkBoard,
  placement,
}: IProps) {
  const {isSmall} = useScreenType();

  const getAdElement = (index: number) => {
    if (talkBoard) {
      const orderNum =
        index / (isSmall ? 3 * AD_LINE_NUMBER : 4 * AD_LINE_NUMBER);
      return (
        <AdBanner
          banner={talkBoard}
          onClick={() => {
            sendHomeEvent({
              actionName: 'banner',
              action: 'click',
              customProps: {
                placement,
                banner_id: talkBoard.id,
                event_layer: 'banner',
                ordnum: orderNum,
                cardgroup_id: talkBoard.cardgroupId,
              },
            });
          }}
          onIntersection={isIntersecting => {
            if (isIntersecting) {
              sendHomeViewImp({
                customProps: {
                  placement,
                  banner_id: talkBoard.id,
                  event_layer: 'banner',
                  ordnum: orderNum,
                  cardgroup_id: talkBoard.cardgroupId,
                },
                viewImpContents: {
                  name: 'banner',
                },
              });
            }
          }}
        />
      );
    }
  };
  const handleClickBigContent = () => {
    bigContent &&
      sendHomeEvent({
        actionName: 'content',
        action: 'click',
        customProps: {
          placement,
          event_layer: 'section',
          content_id: bigContent.id,
          ordnum: 1,
        },
      });
  };
  const handleClickContent = ({
    id,
    sid,
    index,
  }: {
    id: number;
    sid: string;
    index: number;
  }) => {
    sendHomeEvent({
      actionName: 'content',
      action: 'click',
      customProps: {
        event_layer: 'section',
        content_id: id,
        ordnum: getContentOrdNum(index, !!bigContent),
        placement,
      },
    });
    routeTo({page: Page.Content, id, sid});
  };

  const onSendContentViewImp = ({id, index}: {id: number; index: number}) => {
    sendHomeViewImp({
      customProps: {
        placement,
        content_id: id,
        event_layer: 'section',
        ordnum: getContentOrdNum(index, !!bigContent),
      },
      viewImpContents: {
        name: 'card',
      },
    });
  };

  const onSendBigContetnViewImp = () => {
    bigContent &&
      sendHomeViewImp({
        customProps: {
          placement,
          content_id: bigContent.id,
          event_layer: 'section',
          ordnum: 1,
        },
        viewImpContents: {
          name: 'card',
        },
      });
  };
  const handleClickPromotionVideo = () => {
    bigContent &&
      sendHomeEvent({
        actionName: 'content',
        action: 'click',
        customProps: {
          event_layer: 'section',
          content_id: bigContent.id,
          ordnum: 1,
        },
      });
  };
  const handleClickPromotionVideoMute = (isMute: boolean) => {
    bigContent &&
      sendHomeEvent({
        actionName: 'video_sound',
        action: 'click',
        customProps: {
          placement,
          content_id: bigContent.id,
          event_layer: 'section',
          is_sound_on: isMute ? 'N' : 'Y',
          ordnum: 1,
        },
      });
  };
  const handleClickPromotionVideoPlay = () => {
    bigContent &&
      sendHomeEvent({
        actionName: 'video',
        action: 'play',
        customProps: {
          placement,
          content_id: bigContent.id,
          event_layer: 'section',
          ordnum: 1,
        },
      });
  };

  return (
    <>
      {bigContent && (
        <BigOverContentCardV4
          content={bigContent}
          blackBadgeList={bigContent.blackBadgeList}
          rankingInfo={{
            ranking: bigContent.ranking,
            delta: bigContent.delta,
          }}
          onClickContent={handleClickBigContent}
          onSendViewImp={onSendBigContetnViewImp}
          onClickPromotionVideo={handleClickPromotionVideo}
          onClickPromotionVideoMute={handleClickPromotionVideoMute}
          onClickPromotionVideoPlay={handleClickPromotionVideoPlay}
        />
      )}
      {contents.length > 0 && (
        <ContentCardWrapperV4
          className={cn('relative w-full', {
            'mt-4': !!bigContent,
          })}
          adLineNumber={AD_LINE_NUMBER}
          getAdElement={getAdElement}
          showEmptyContentCard
        >
          {contents.map((content, index) => (
            <RankingContentCard
              key={index}
              index={index}
              content={content}
              onSendContentViewImp={id => onSendContentViewImp({id, index})}
              onClick={(id, sid) => handleClickContent({id, sid, index})}
            />
          ))}
        </ContentCardWrapperV4>
      )}
    </>
  );
}

const AD_LINE_NUMBER = 9;
